export const EmailInbox = () => {
  return (
    <svg
      fill="none"
      height="74"
      viewBox="0 0 74 74"
      width="74"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.0884 48.6611H36.5029V71.6879H47.0884V48.6611Z"
        fill="#C87D5E"
      />
      <path
        d="M47.0884 54.4772C46.1403 52.9393 44.8857 51.627 43.3017 50.7714C42.3189 50.2395 41.232 49.9331 40.1278 49.8232H38.2836C37.6823 49.8811 37.0811 49.9967 36.5029 50.1701V61.8078C37.0175 61.0215 37.8731 60.455 38.7981 60.2353C40.4111 59.8595 42.1223 60.4781 43.4289 61.4898C44.7354 62.5015 45.7125 63.8775 46.6664 65.2245C46.8109 65.4268 46.9496 65.6234 47.0942 65.8257V54.4772H47.0884Z"
        fill="#874D36"
      />
      <path
        d="M16.7308 16.748C23.5874 16.748 29.1663 21.3846 29.1663 27.0907V54.6095H4.28955V27.0907C4.28955 21.3846 9.86846 16.748 16.7308 16.748Z"
        fill="#4E342E"
      />
      <path
        d="M31.7798 54.4532H11.0598C9.82837 54.4532 8.78775 53.5455 8.62009 52.3257L5.70634 31.1489C5.56759 30.1372 6.35384 29.2354 7.37712 29.2354H31.7798V54.4532Z"
        fill="white"
      />
      <path
        d="M56.3961 14.5049H16.731C16.731 14.5049 30.3631 16.1757 30.3631 27.6746L30.4325 56.8583H68.8894C70.433 56.8583 71.6817 55.6096 71.6817 54.066V29.7963C71.6875 21.3499 64.8425 14.5049 56.3961 14.5049Z"
        fill="#1976D2"
      />
      <path
        d="M48.2559 19.6617L43.55 19.8236L36.6992 30.3339C36.6992 30.3339 36.6992 24.7665 36.6992 21.8065C36.6992 17.2509 32.0742 14.499 32.0742 14.499H50.0886L50.1811 14.5915C52.0716 16.3895 50.8633 19.5692 48.2559 19.6617Z"
        fill="#0D47A1"
      />
      <path
        d="M42.9027 36.5493C45.5017 36.5493 47.6087 34.1783 47.6087 31.2536C47.6087 28.3289 45.5017 25.958 42.9027 25.958C40.3037 25.958 38.1968 28.3289 38.1968 31.2536C38.1968 34.1783 40.3037 36.5493 42.9027 36.5493Z"
        fill="#0D47A1"
      />
      <path
        d="M38.6709 5.84484L38.6882 29.8717C38.6882 30.6811 39.3415 31.3344 40.1509 31.3344H43.1051C43.9145 31.3344 44.5678 30.6811 44.5678 29.8717V2.3125H42.1975C40.2492 2.3125 38.6709 3.89078 38.6709 5.84484Z"
        fill="#C62828"
      />
      <path
        d="M39.96 5.84484L39.9773 29.8717H44.7006V11.2677H52.8406C54.7195 11.2677 54.9392 10.4525 54.9392 6.90281C54.9392 3.35312 54.7253 2.3125 52.8464 2.3125H43.4865C41.5382 2.3125 39.96 3.89078 39.96 5.84484Z"
        fill="#F44336"
      />
      <path
        d="M43.0064 6.29026C42.966 7.44073 42.2144 17.8585 42.0814 19.8126C41.9196 22.1771 40.5552 22.4199 40.5552 20.2693V6.1862C40.561 3.90838 43.0931 3.78698 43.0064 6.29026Z"
        fill="#FF7555"
      />
      <path
        d="M42.4344 24.5361L42.4748 35.1215C42.4748 35.1215 41.3475 35.1215 40.0814 35.1215C37.74 35.1215 35.8438 32.7512 35.8438 29.8259C35.8438 26.9006 37.74 24.5303 40.0814 24.5303C42.4228 24.5303 42.4344 24.5361 42.4344 24.5361Z"
        fill="#82AEC0"
      />
      <path
        d="M42.4344 35.1215C44.7748 35.1215 46.6721 32.7506 46.6721 29.8259C46.6721 26.9012 44.7748 24.5303 42.4344 24.5303C40.094 24.5303 38.1968 26.9012 38.1968 29.8259C38.1968 32.7506 40.094 35.1215 42.4344 35.1215Z"
        fill="#E0E0E0"
      />
      <path
        d="M39.9021 29.9819C40.1565 30.109 40.4629 29.9703 40.6826 29.7853C41.3532 29.2245 41.6076 28.2995 42.2262 27.6867C42.7696 27.1433 43.5963 26.6114 42.9488 25.8078C42.4805 25.2297 41.6885 25.328 41.0699 25.5939C39.6998 26.1662 38.6129 29.3344 39.9021 29.9819Z"
        fill="white"
      />
      <path
        d="M16.7309 16.8983C23.5355 16.8983 29.0739 21.5002 29.0739 27.16V54.4591H4.38797V27.1543C4.38797 21.5002 9.92641 16.8983 16.7309 16.8983ZM16.7309 14.5049C7.98391 14.5049 2.3125 20.396 2.3125 27.6688V55.6211C2.3125 56.2975 2.86172 56.8525 3.54391 56.8525H31.3459C32.0223 56.8525 32.5773 56.3033 32.5773 55.6211V27.6688C32.5658 20.396 25.478 14.5049 16.7309 14.5049Z"
        fill="#4FC3F7"
      />
      <path
        d="M10.2211 52.8986C9.87999 52.7194 10.1633 52.3783 10.3541 52.0661L18.0836 38.6016L19.6041 39.5266L11.0016 52.465C10.7819 52.8003 10.5622 53.0778 10.2211 52.8986Z"
        fill="#6FBFF0"
        stroke="#6FBFF0"
        strokeMiterlimit="10"
        strokeWidth="0.171875"
      />
      <path
        d="M23.0613 43.3188L7.02415 31.0048C6.82758 30.8718 6.65993 30.629 6.86227 30.3862C7.02415 30.1896 7.17446 30.2937 7.45774 30.4613L22.9977 41.1682C23.3909 41.411 23.8996 41.307 24.1713 40.937L28.8079 34.6585L28.7963 37.474L24.8882 42.9893C24.4604 43.5732 23.6568 43.7177 23.0613 43.3188Z"
        fill="#6FBFF0"
        stroke="#6FBFF0"
        strokeMiterlimit="10"
        strokeWidth="0.171875"
      />
    </svg>
  );
};
